/*
 * Ryan O'Dowd
 * 2019-06-08
 * © Copyright 2019 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import globals from '@utils/globals';

const getStyles = ({globalScale, colors, fonts}) => {
  return {
    container: {
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'center',
      backgroundColor: colors.primaryExtraDark,
      color: colors.white,
    },
    headerInner: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      justifyContent: 'space-between',
      marginTop: 4,
      marginLeft: 8,
      marginBottom: 4,
      alignItems: 'center',
      // @TODO: height: 72,
    },
    menuSectionHeader: {
      marginTop: 12,
      marginLeft: 16,
      marginBottom: 4,
      fontSize: globalScale * 14,
      fontFamily: fonts.primaryBold,
    },
    italicized: {
      fontFamily: fonts.primaryItalic,
    },
    nested: (levels) => {
      return {
        paddingLeft: levels * (globalScale * 20),
      };
    },
    logoAndName: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      textDecoration: 'initial',
      color: 'white',
      cursor: 'pointer',
    },
    logo: {
      width: 38,
      height: 38,
      marginRight: 8,
      marginLeft: 8,
      borderRadius: 6,
    },
    appTitle: {
      fontSize: (globals.deviceType === 'mobile') ? 32 : 42,
      fontFamily: fonts.primaryBold,
      color: colors.white,
    },
    navigationTabsWrapper: {
      marginTop: 2,
      marginLeft: 8,
      marginBottom: 2,
      marginRight: 8,
    },
    navigationTabsWrapperMobile: {
      flex: 1,
      justifySelf: 'flex-start',
      marginLeft: 0,
    },
    buttons: {
      flexDirection: 'row',
      alignItems: 'center',
      marginRight: 8,
      marginLeft: 8,
    },
    userImage: {
      width: globalScale * 50,
      height: globalScale * 50,
      objectFit: 'cover',
      marginRight: 10,
      borderRadius: globalScale * 6,
    },
    profileInfoWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      marginVertical: globalScale * 4,
      marginHorizontal: globalScale * 12,
    },
    userInfoWrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    displayNameText: {
      fontSize: globalScale * 16,
      fontFamily: fonts.primaryBold,
    },
    usernameText: {
      fontSize: globalScale * 12,
    },
    emailText: {
      fontSize: globalScale * 12,
    },
    divider: {
      backgroundColor: colors.dialogText,
      width: '100%',
      height: 2,
      opacity: 0.3,
    },
    downloadsWrapper: {
      padding: 4,
      paddingHorizontal: 12,
      width: 'max-content',
    },
    menuItem: {
      maxWidth: 'initial',
    },
  };
};

export default getStyles;
